// components/CookieBanner.jsx
import React from 'react';
import CookieConsent from 'react-cookie-consent';

const CookieBanner = () => {
  const handleDecline = () => {
    console.log("Cookies declined. Redirecting...");
    window.location.href = "https://google.com"; // Option 1: Redirect to external site
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept All"
      declineButtonText="Decline"
      enableDeclineButton
      cookieName="siteCookieConsent"
      style={styles.banner}
      buttonStyle={styles.acceptButton}
      declineButtonStyle={styles.declineButton}
      expires={365}
      onDecline={handleDecline}
    >
        Ta strona korzysta z ciasteczek.{" "}
      <span style={{ color: "#4e9ef7", textDecoration: 'underline' }}>
        By dalej kontynuować zaakceptuj.
      </span>
    </CookieConsent>
  );
};

const styles = {
  banner: {
    background: "#2B373B",
    color: "white",
    fontSize: "14px",
    padding: "1rem",
  },
  acceptButton: {
    background: "#4CAF50",
    color: "white",
    fontSize: "13px",
    borderRadius: "5px",
    padding: "0.5rem 1rem",
  },
  declineButton: {
    background: "#f44336",
    color: "white",
    fontSize: "13px",
    borderRadius: "5px",
    padding: "0.5rem 1rem",
    marginLeft: "0.5rem",
  }
};

export default CookieBanner;
